(() => {
 if(window.mhMotion||!window.gsap)return;
 const gsap=window.gsap;
 const reduced=matchMedia('(prefers-reduced-motion:reduce)');
 const seen=new WeakSet();
 const active=new Set();
 const settings={duration:.9,ease:'power3.out',distance:28,stagger:.065};
 const reveal=(elements,delay=0)=>{
  if(reduced.matches)return;
  const targets=[...elements].filter(el=>el.isConnected);
  if(!targets.length)return;
  const tween=gsap.to(targets,{y:0,opacity:1,duration:settings.duration,ease:settings.ease,stagger:settings.stagger,delay,overwrite:'auto',clearProps:'transform,opacity',onComplete:()=>active.delete(tween)});
  active.add(tween);
 };
 window.mhMotion={settings,reveal};
 const observer=new IntersectionObserver(entries=>{
  const visible=entries.filter(entry=>entry.isIntersecting).map(entry=>entry.target);
  visible.forEach(el=>observer.unobserve(el));
  reveal(visible);
 },{threshold:.06,rootMargin:'0px 0px -24px 0px'});
 const boot=()=>{
  document.querySelectorAll('[data-svc-reveal]').forEach(el=>el.classList.add('is-visible'));
  document.querySelectorAll('[data-svc-reveal],[data-mh-reveal],.mh-pro-hero__copy,.mh-pro-category,.mh-pro-product,.mh-collection-editorial__copy,main .product-card,main .mh-collection-editorial__types>a,main .mh-collection-editorial__search,main h1,main h2').forEach(el=>{
   if(seen.has(el)||el.closest('#cart-drawer,.cart-page,.mh-pdp,[data-mh-contact],[data-mh-svc],.menu-list__submenu,.mh-journey,.mh-pro-workshop--cinema,.mh-pro-manual__stage'))return;
   if(el.matches('h1,h2')&&el.closest('[data-svc-reveal],[data-mh-reveal],.mh-pro-hero__copy,.mh-collection-editorial__copy,.product-card,.mh-pro-product,.mh-pro-category'))return;
   seen.add(el);el.classList.add('mh-motion-managed');
   if(!reduced.matches){gsap.set(el,{y:settings.distance,opacity:0});observer.observe(el);}
  });
 };
 document.addEventListener('pointerover',event=>{
  if(reduced.matches||event.pointerType==='touch')return;
  const button=event.target.closest('main button,main .mh-svc__textlink,main .mh-svc__button,main .mh-pro-button');
  if(!button||button.closest('#cart-drawer,.cart-page,.mh-pdp,product-card,[data-mh-svc],[data-mh-contact],.mh-unified-search')||button.contains(event.relatedTarget))return;
  gsap.to(button,{opacity:.9,duration:.22,ease:'power3.out',overwrite:'auto'});
 });
 document.addEventListener('pointerout',event=>{
  if(reduced.matches)return;
  const button=event.target.closest('main button,main .mh-svc__textlink,main .mh-svc__button,main .mh-pro-button');
  if(!button||button.closest('#cart-drawer,.cart-page,.mh-pdp,product-card,[data-mh-svc],[data-mh-contact],.mh-unified-search')||button.contains(event.relatedTarget))return;
  gsap.to(button,{opacity:1,duration:.28,ease:'power3.out',overwrite:'auto',clearProps:'opacity'});
 });
 reduced.addEventListener('change',()=>{
  if(reduced.matches){active.forEach(tween=>{tween.progress(1);tween.kill();});active.clear();observer.disconnect();gsap.set('.mh-motion-managed',{clearProps:'transform,opacity,clipPath'});}
 });
 boot();document.addEventListener('DOMContentLoaded',boot);document.addEventListener('shopify:section:load',boot);
 document.addEventListener('shopify:section:unload',()=>active.forEach(tween=>{if(tween.targets().some(el=>!el.isConnected)){tween.kill();active.delete(tween);}}));
 document.addEventListener('facets:update',boot);
 const main=document.querySelector('main');
 if(main){let queued=false;new MutationObserver(records=>{if(queued||!records.some(record=>[...record.addedNodes].some(node=>node.nodeType===1)))return;queued=true;requestAnimationFrame(()=>{queued=false;boot();});}).observe(main,{childList:true,subtree:true});}
})();
